<template>
  <div class="result-upper-row">
    <div class="container">
      <div class="row align-items-start flex-column-reverse flex-sm-row">
        <div class="col-sm-12 col-lg-6 col-md-7">
          <div class="backbutton-container">
            <a href="/#goals" class="btn-textlinkLeftIcon"><span><i class="ph-arrow-left-bold"></i></span>back</a>
          </div>
          <div class="investment-container">
            <h2 class="hf_heading02">What you need to know about your investment</h2>
            <!-- CALCULATOR SECTION -->
            <div class="calc-outer-container calculator-box">
              <div class="goals-calc-container">
                <div class="goals-calculator-box">
                  <div class="calculator">
                    <!-- calculator section for wealth goal -->
                    <form action="#" role="form" class="goalWealth">
                      <input type="hidden" v-model="_token" name="_token">

								      <div class="form-group dynamic-input">
								        <label>I want to invest<span class="inr-symbol hf_dark">&#8377;</span></label>
								        <input type="text" id="lumpamt" name="lumpamt" v-model="lumpamtPass" class="restDot numbersonly" :class="lumpamtMClass" @keyup="resetCalculation()" placeholder="1,00,000" min="0" maxlength="14" required>
								        <span>one-time and</span>
								      </div>
								      <div class="form-group dynamic-input">
								        <label for="name"><span>&#8377;</span></label>
								        <input type="text" id="sipamt" name="sipamt" v-model="sipamtPass" class="restDot numbersonly" :class="sipamtMClass" @keyup="resetCalculation()" placeholder="10,000" min="0" maxlength="14" required>
								        <span>monthly for a period of
								        	<input type="number" id="year" name="yearReqd" v-model="yearReqdPass" class="restDot numbersonly width-dynamic" :class="yearReqdMClass" @keyup="resetCalculation()" placeholder="20" min="0" maxlength="2" @input="updateYearVal()" required>
								        	years.
								        </span>
								      </div>
                      <div class="notification-message">
                        <p v-show="showError" class="errorMessage inflation-text hf_bodytext02">
                          <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
  			                  {{ showErrorText }}
  			                </p>
                      </div>
                      <div class="recalculate-button-container">
                        <a href="javascript:void(0)" type="button" class="btn-textlinkLeftIcon lg-textlinkleftIcon" ref="myBtn" @click.stop="showResult($event)"><span class="ph-arrow-clockwise-bold"></span>Recalculate</a>
                      </div>
                    </form>
                    <!-- end calculator section for wealth goal -->
                  </div>
                </div>
              </div>
            </div>
            <!-- END CALCULATOR SECTION -->
            <!-- CALCULATIONS RESULT SECTION -->
            <div class="calc-result-container">
                <!-- wealth goal result -->
                  <!-- Considering inflation of <span class="calculation-number">{{ inflation }}</span>%, -->
                  <p class="hf_bodytext01 goalWealth">You would build a wealth corpus of <span class="inr-symbol hf_dark">&#8377;</span><span class="calculation-number">{{ fvResultHtml }}</span> by <span class="calculation-number">{{ accmpYear }}</span>.</p>
                  <!-- end wealth goal result -->
            </div>
            <!-- END CALCULATIONS RESULT SECTION -->
            <!-- INVESTMENT SECTION -->
              <div class="current-invest-box">
              </div>
            <!-- END INVESTMENT SECTION -->
            <!-- INSIGHT SECTION FOR ONLY WEALTH GOAL -->
              <div class="insight-container goalWealth">
                <p class="hf_subheading">Valuable insights for you</p>
                <ul class="insight-list">
                  <li>Successful wealth creation depends on how early and consistently you invest.</li>
                  <li>Creating wealth enables you to buy yourself time to do whatever you desire and live the life you wish for. </li>
                </ul>
              </div>
            <!-- END INSIGHT SECTION FOR ONLY WEALTH GOAL -->
          </div>
        </div>
        <!-- GOAL IMAGES SECTION -->
        <div class="col-sm-12 col-lg-6 col-md-5">
          <div class="goal-image-box">
            <img src="img/goal-wealth.webp" class="goalWealth" alt="">
          </div>
        </div>
        <!-- END GOAL IMAGES SECTION -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  data() {
    return {
    	_token : this.$token,
    	validationflag: 0,
    	fvResultHtml: '',
    	accmpYear: '',
      lumpamtMClass: '',
      sipamtMClass: '',
      yearReqdMClass: '',
      mandatoryClassName: 'redunderline',
    	showErrorText: '',
    	showError: false,
    	inflation: '',
      lumpamtPass: '',
      sipamtPass: '',
      yearReqdPass: '',
    };
  },
  props: { 
  	lumpamt: { type:String, default:''},
  	sipamt: { type:String, default:''},
  	yearReqd: { type:String, default:''},
  },
  watch: {
    lumpamtPass(){
      var res =  this.formatAmount(this.lumpamtPass)
      this.lumpamtPass = res;
    },
    sipamtPass(){
      var res =  this.formatAmount(this.sipamtPass)
      this.sipamtPass = res;
    },
  },
  mounted(){
    this.lumpamtPass = this.lumpamt;
    this.sipamtPass = this.sipamt;
    this.yearReqdPass = this.yearReqd;

  	let temp = this.$refs.myBtn;
  	setTimeout(function() {
      temp.click();
    }, 1000);
  },
  methods: {
    updateYearVal: function(){
      var element = event.target;
      var maxlength = element.getAttribute('maxlength');
      if(this.yearReqdPass.toString().length > maxlength){
        let number = this.yearReqdPass;
        this.yearReqdPass = number.toString().substring(0, number.toString().length - 1);
      }
    },
  	showResult(e){
  		// console.log("Click event triggered");

  		//Check for validation and collect data for calculations
  		//======================================================
  		let sipamt = this.sipamtPass;
      sipamt = String(sipamt).replace(new RegExp(',', 'g'), '');
  		let lumpamt = this.lumpamtPass;
      lumpamt = String(lumpamt).replace(new RegExp(',', 'g'), '');
  		let yearReqd = this.yearReqdPass;

  		if((sipamt == "" || sipamt == undefined) && (lumpamt == "" || lumpamt == undefined) || yearReqd == "" || yearReqd == undefined){
  			this.validationflag = 0;
  			this.showErrorText = "Please enter mandatory data first";
  			this.showError = true;

        // Check for mandatory fields
        //==============================
        if(sipamt == "" || sipamt == undefined){
          this.sipamtMClass = this.mandatoryClassName;
        }else{
          this.sipamtMClass = "";
        }

        if(lumpamt == "" || lumpamt == undefined){
          this.lumpamtMClass = this.mandatoryClassName;
        }else{
          this.lumpamtMClass = "";
        }

        if(yearReqd == "" || yearReqd == undefined){
          this.yearReqdMClass = this.mandatoryClassName;
        }else{
          this.yearReqdMClass = "";
        }

  		}else{
        //remove all redunderline class for mandatory
        //============================================
        this.sipamtMClass = "";
        this.lumpamtMClass = "";
        this.yearReqdMClass = "";

  			//Check all the basic validations eg.age, amt
				//=============================================
				axios.post('/chkWealthGoalValidations',{sipamt: sipamt, lumpamt: lumpamt, yearReqd: yearReqd, calcReq: 1, _token: this.$token})
        .then((response)=>{
        	// console.log(response);
        	let resData = response.data;
        	if(resData.status == true){
						this.showErrorText = "";
			    	this.showError = false;

        		let inflrateData = resData.inflrate; 
			    	let inflrate = inflrateData['inflrate'];
			    	this.inflation = Math.round(inflrate*100);

			    	this.accmpYear = (parseInt(new Date().getFullYear()) + parseInt(yearReqd));

       			//	Call api to get FV
	  				// ====================================
	  				axios.post('/csdCalcFV',{sipInvst: sipamt, lumpsumInvst: lumpamt, noOfMonths: (yearReqd*12), _token: this.$token})
	          .then((result)=>{
	          	// console.log(result);
	          	let fvData = result.data;
                if(fvData.status == 1){
                	let fvResultApi = JSON.parse(fvData.result);
                  let futureValue = fvResultApi.futureValue;
	          			this.fvResultHtml = this.shorthandCurrency(Math.round(futureValue), true);
                }else{
                	this.showErrorText = resData.errcode+"  "+(resData.errmsg ? resData.errmsg : '');
                  this.showError = false;
                }
	          }).catch(result => {
				        console.log(result.data)
				    });

        	}else{
            if(resData.error == undefined){
              this.showErrorText = "Page session expired, Please refresh the page";
              this.showError = true;
            }else{
              this.showErrorText = resData.error;
              this.showError = true;
            }
        	}
        }).catch(response => {
		        console.log(response.data);
		    })

  		}
  	},
  	resetCalculation(){
      // On keyup of field show button for calculation and hide result 
			//================================================================
			this.showErrorText = "";
    	this.showError = false;
    },
    resetSipMClass(){
      this.sipamtMClass = "";
    },
    resetLumpMClass(){
      this.lumpamtMClass = "";
    }
  },
};
</script>

<style lang="scss" scoped></style>
